<section class="service-page">
  <div class="row pad">
    <div class="service-page__inner">
      <h1>Event Privacy Notices</h1>

      <p>
        Privacy notices for MARI events and sites are listed below.
      </p>

      <div class="table-container">
        <table>
          <thead>
            <tr>
              <th scope="col">Category</th>
              <th scope="col">Event or Site</th>
              <th scope="col">Privacy Notice</th>
              <th scope="col">Website</th>
            </tr>
          </thead>
          <tbody>
            @for (notice of eventPrivacyNotices; track notice.eventOrSite) {
              <tr>
                <td>{{ notice.category }}</td>
                <td>{{ notice.eventOrSite }}</td>
                <td>
                  @if (notice.internalPrivacyNotice) {
                    <a [routerLink]="notice.privacyNoticeUrl">{{
                      notice.privacyNotice
                    }}</a>
                  } @else {
                    <a
                      [href]="notice.privacyNoticeUrl"
                      target="_blank"
                      rel="noopener noreferrer"
                      >{{ notice.privacyNotice }}</a
                    >
                  }
                </td>
                <td>
                  <a
                    [href]="'https://' + notice.website"
                    target="_blank"
                    rel="noopener noreferrer"
                    >{{ notice.website }}</a
                  >
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
</section>
